<template>
  <v-container>
    <v-app-bar color="transparent" class="page-header-toolbar">
      <h2 class="page-title">{{ $t("checklist.forms") }}</h2>
    </v-app-bar>

    <v-card :loading="loading">
      <v-card-text class="pa-4">
        <v-layout row wrap>
          <v-flex lg12 md12 sm12 xs12>
            <span class="justify-space-between font-weight-bold"> {{ $t("customer.module") }}: </span>
            {{ equipment.customer_name }}
          </v-flex>
          <v-flex lg2 md4 sm6 xs12>
            <v-expand-transition>
              <v-responsive max-width="350">
                <div class="justify-space-between">
                  <div>
                    <div class="font-weight-bold">
                      {{ $t("equipmentfabricat.module") }}
                    </div>

                    <div class="">{{ equipment.fabricat_name }}</div>
                  </div>
                </div>
              </v-responsive>
            </v-expand-transition>
          </v-flex>
          <v-flex lg2 md4 sm6 xs12>
            <v-expand-transition>
              <v-responsive max-width="350">
                <div class="justify-space-between">
                  <div>
                    <div class="font-weight-bold">
                      {{ $t("equipmentmodel.module") }}
                    </div>

                    <div class="">{{ equipment.model_name }}</div>
                  </div>
                </div>
              </v-responsive>
            </v-expand-transition>
          </v-flex>
          <v-flex lg2 md4 sm6 xs12>
            <v-expand-transition>
              <v-responsive max-width="350">
                <div class="justify-space-between">
                  <div>
                    <div class="font-weight-bold">
                      {{ $t("equipmentcategory.module") }}
                    </div>

                    <div class="">{{ equipment.category_name }}</div>
                  </div>
                </div>
              </v-responsive>
            </v-expand-transition>
          </v-flex>
          <v-flex lg2 md4 sm6 xs12>
            <v-expand-transition>
              <v-responsive max-width="350">
                <div class="justify-space-between">
                  <div>
                    <div class="font-weight-bold">
                      {{ $t("equipmenttype.module") }}
                    </div>

                    <div class="">{{ equipment.type_name }}</div>
                  </div>
                </div>
              </v-responsive>
            </v-expand-transition>
          </v-flex>
          <v-flex lg2 md4 sm6 xs12>
            <v-expand-transition>
              <v-responsive max-width="350">
                <div class="justify-space-between">
                  <div>
                    <div class="font-weight-bold">
                      {{ $t("equipment.intern_nr") }}
                    </div>

                    <div class="">{{ equipment.equipment_no }}</div>
                  </div>
                </div>
              </v-responsive>
            </v-expand-transition>
          </v-flex>
          <v-flex lg2 md4 sm6 xs12>
            <v-expand-transition>
              <v-responsive max-width="350">
                <div class="justify-space-between">
                  <div>
                    <div class="font-weight-bold">
                      {{ $t("equipment.equipment_no") }}
                    </div>

                    <div class="">{{ equipment.intern_nr }}</div>
                  </div>
                </div>
              </v-responsive>
            </v-expand-transition>
          </v-flex>

          <v-flex lg12 md12 sm12 xs12 class="mt-1">
            <p class="ma-0" v-for="(label, index) in template.formula_type_label" :key="index">
              <strong>{{ label }}</strong>
            </p>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <form-render
      :formId="formid"
      :checklistId="checklistid"
      :isFinished="isFinished"
      @update="update"
      @close="close"
      :formulaType="formulaType"
    >
    </form-render>
  </v-container>
</template>

<script>
import { checklistApi } from "@/plugins/api_settings"

export default {
  name: "forms",

  props: ["checklistid", "formid", "orderid", "inspectionid", "equipmentId"],
  data() {
    return {
      /* isFinished Prop for component requirement */
      isFinished: false,
      canChangeRadioStatus: false,
      checklist: [],
      inspection: [],
      equipment: [],
      formulaType: 1,
      template: [],
      loading: false
    }
  },

  components: {
    "form-render": () => import("@/mixins/components/checklist/render/Index")
  },

  mounted() {
    this.isFinished = false

    if (this.checklistid) {
      // Get inspection
      axios
        .get(this.API_URL + `checklist/${this.checklistid}/edit?is_api=1`)
        .then((response) => {
          if (response.status == 200) {
            this.checklist = response.data
            this.equipment = response.data.equipment
            this.inspection = response.data.inspection
            this.template = response.data.template
            this.isFinished = this.inspection.isfinal == 1 ? true : false
            this.formulaType = this.template.formula_type
          }
        })
        .catch((error) => {})
    }
  },

  methods: {
    update(data) {
      this.loading = true
      axios
        .put(this.API_URL + `checklist/${this.checklistid}`, data)
        .then((response) => {
          this.$awn.success(
            this.$t("global.update_success", {
              module: this.$t("checklist.module")
            })
          )
          // if (response.status == 200) {
          //   this.customer = response.data;
          //   this.$awn.success(this.$t("global.update_success", { module: this.$t("checklist.module")}));
          //   this.$router.push(this.APP_URL + "customers").catch(() => {});
          // }
        })
        .catch((error) => {
          this.$handleServerSideError(error)
        })
        .then(() => {
          this.loading = false
        })
    },
    close() {
      if (this.orderid && this.orderid != null) {
        this.$router.push(this.APP_URL + `order/${this.orderid}/inspection/view/${this.inspectionid}`).catch(() => {})
      } else {
        this.$router.push(this.APP_URL + `equipment/${this.equipmentId}/inspection/view/${this.inspectionid}`).catch(() => {})
      }
    }
  }
}
</script>
